import { defineComponent, useListeners, ref, computed, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import UiName from '../ui-name/UiName.vue.js';
import UiValue from '../ui-value/UiValue.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertTriggerToggle",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true },
    hasIconTitle: { type: Boolean, required: false, default: false }
  },
  emits: ["store-error", "data-load", "on-control-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const button = ref(null);
    const tooltipIsVisible = ref(false);
    const componentInputs = computed(() => ({
      id: props.id,
      language: props.locale
    }));
    const isActive = computed(() => {
      var _a;
      return ((_a = storeData.value) == null ? void 0 : _a.status) === "active";
    });
    const isTriggered = computed(() => {
      var _a;
      return ((_a = storeData.value) == null ? void 0 : _a.status) === "triggered";
    });
    const isInactive = computed(() => !isActive.value && !isTriggered.value);
    const isAlertDisabled = (alert) => {
      return alert === null || alert === void 0;
    };
    const iconTitle = computed(() => {
      if (props.hasIconTitle) {
        return isActive.value || isTriggered.value ? translate("alertTriggerToggle.edit") : translate("alertTriggerToggle.add");
      }
      return void 0;
    });
    const hasControlClickListener = computed(() => {
      return Object.prototype.hasOwnProperty.call(listeners, "on-control-click");
    });
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, numberFormat, dateFormat } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData } = storeModule;
    const onControlClick = () => {
      if (hasControlClickListener.value) {
        emits("on-control-click");
      }
    };
    const openTooltip = () => {
      tooltipIsVisible.value = true;
    };
    const closeTooltip = () => {
      if (!infoIsActive()) {
        tooltipIsVisible.value = false;
      }
    };
    const infoIsActive = () => {
      const { activeElement } = document;
      return activeElement === button.value;
    };
    return { __sfc: true, props, emits, listeners, button, tooltipIsVisible, componentInputs, isActive, isTriggered, isInactive, isAlertDisabled, iconTitle, hasControlClickListener, localizationSupport, translate, numberFormat, dateFormat, storeModule, storeData, onControlClick, openTooltip, closeTooltip, infoIsActive, UiName, UiValue, HoistComponent };
  }
});

export { _sfc_main as default };
